import callApi from './backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getSerials = () => callApi({
  method: 'GET',
  endpoint: `${basePath}/sn-code-push-event`
});

export const sendPoint = (data) => callApi({
  method: 'POST',
  endpoint: `${basePath}/sn-code-push-event`,
  body: data
});
